export { default as Img200 } from './processed/200/Dont-Say-A-Word.jpg';
export { default as Img400 } from './processed/400/Dont-Say-A-Word.jpg';
export { default as Imgthumb } from './processed/thumb/Dont-Say-A-Word.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Dont-Say-A-Word.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Dont-Say-A-Word.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      204,
      140,
      76
    ],
    "_population": 6,
    "_hsl": [
      0.08333333333333336,
      0.5565217391304348,
      0.5490196078431373
    ]
  },
  "LightVibrant": {
    "_rgb": [
      228,
      174,
      112
    ],
    "_population": 4,
    "_hsl": [
      0.08908045977011493,
      0.6823529411764706,
      0.6666666666666667
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      31,
      50,
      105
    ],
    "_population": 2831,
    "_hsl": [
      0.6238738738738738,
      0.5441176470588235,
      0.26666666666666666
    ]
  },
  "Muted": {
    "_rgb": [
      78,
      92,
      140
    ],
    "_population": 3,
    "_hsl": [
      0.6290322580645161,
      0.28440366972477066,
      0.4274509803921569
    ]
  },
  "LightMuted": {
    "_rgb": [
      202,
      178,
      167
    ],
    "_population": 44,
    "_hsl": [
      0.05238095238095234,
      0.2482269503546098,
      0.7235294117647059
    ]
  },
  "DarkMuted": {
    "_rgb": [
      57,
      62,
      103
    ],
    "_population": 93,
    "_hsl": [
      0.6485507246376812,
      0.2875,
      0.3137254901960784
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Dont-Say-A-Word.js